import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/api";

const inputCls = "border-white/10 bg-white/5 text-white placeholder:text-slate-500 focus-visible:border-[#FF4500] focus-visible:ring-[#FF4500]/30";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Inloggen mislukt");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#090B0E] px-6" data-testid="login-page">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#12151D] p-10">
        <div className="flex flex-col items-center">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#FF4500]/10 text-[#FF4500]"><Lock className="h-5 w-5" /></span>
          <h1 className="mt-5 font-display text-2xl font-semibold text-white">Admin login</h1>
          <p className="mt-2 text-sm text-slate-400">Imperium Group beheeromgeving</p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
          <div className="space-y-2">
            <Label className="text-sm text-slate-300">E-mailadres</Label>
            <Input data-testid="login-email" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@imperiumgroup.nl" />
          </div>
          <div className="space-y-2">
            <Label className="text-sm text-slate-300">Wachtwoord</Label>
            <Input data-testid="login-password" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-xl bg-[#FF4500] px-6 py-3 text-sm font-semibold text-[#090B0E] transition-[background-color,transform] duration-200 hover:bg-[#ff6428] active:scale-95 disabled:opacity-60">
            {loading ? "Bezig..." : "Inloggen"}
          </button>
        </form>
      </div>
    </div>
  );
}
